var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLongPlay618A965(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D16"
    },
    d: "M256,0C114.5,0,0,114.5,0,256s114.5,256,256,256s256-114.5,256-256S397.5,0,256,0z M256,281.6 c-14.151,0-25.6-11.449-25.6-25.6c0-14.151,11.449-25.6,25.6-25.6c14.151,0,25.6,11.449,25.6,25.6 C281.6,270.151,270.151,281.6,256,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M384,256c0-70.75-57.25-128-128-128"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M256,477.867c-59.309,0-115.037-23.065-156.919-64.948C57.198,371.037,34.133,315.309,34.133,256 c0-4.713,3.82-8.533,8.533-8.533S51.2,251.287,51.2,256c0,112.927,91.873,204.8,204.8,204.8c4.714,0,8.533,3.821,8.533,8.533 S260.714,477.867,256,477.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M394.333,102.062c-1.957,0-3.923-0.669-5.53-2.039C351.852,68.54,304.688,51.2,256,51.2 c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533c52.741,0,103.836,18.787,143.872,52.901 c3.586,3.056,4.018,8.442,0.961,12.03C399.146,101.044,396.747,102.062,394.333,102.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M469.333,264.533c-4.714,0-8.533-3.821-8.533-8.533c0-48.687-17.339-95.849-48.822-132.8 c-3.057-3.587-2.626-8.974,0.961-12.03c3.587-3.057,8.974-2.627,12.03,0.961c34.111,40.036,52.898,91.129,52.898,143.869 C477.867,260.713,474.047,264.533,469.333,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M426.667,264.533c-4.714,0-8.533-3.821-8.533-8.533c0-89.401-72.732-162.133-162.133-162.133 c-4.714,0-8.533-3.821-8.533-8.533S251.286,76.8,256,76.8c47.904,0,92.914,18.63,126.743,52.457S435.2,208.096,435.2,256 C435.2,260.713,431.38,264.533,426.667,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M181.724,418.266c-1.247,0-2.512-0.274-3.709-0.853c-29.886-14.449-55.155-36.894-73.075-64.908 C86.531,323.726,76.8,290.355,76.8,256c0-4.713,3.82-8.533,8.533-8.533s8.533,3.821,8.533,8.533 c0,62.777,35.09,118.738,91.576,146.049c4.243,2.051,6.02,7.154,3.967,11.397C187.939,416.492,184.893,418.266,181.724,418.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M256,435.2c-14.999,0-29.905-1.853-44.306-5.51c-4.568-1.161-7.331-5.804-6.171-10.371 s5.807-7.331,10.371-6.171c13.029,3.309,26.524,4.986,40.107,4.986c4.714,0,8.533,3.821,8.533,8.533S260.714,435.2,256,435.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M256,392.533c-38.978,0-76.18-16.693-102.068-45.801c-3.132-3.521-2.816-8.916,0.705-12.047 c3.523-3.132,8.914-2.816,12.048,0.705c22.652,25.468,55.205,40.076,89.314,40.076c4.714,0,8.533,3.821,8.533,8.533 S260.714,392.533,256,392.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M141.226,321.296c-3.144,0-6.167-1.742-7.655-4.75c-9.358-18.91-14.104-39.281-14.104-60.546 c0-4.713,3.82-8.533,8.533-8.533c4.714,0,8.533,3.821,8.533,8.533c0,18.616,4.149,36.44,12.333,52.976 c2.091,4.223,0.361,9.342-3.863,11.432C143.788,321.01,142.496,321.296,141.226,321.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3A2D"
    },
    d: "M384,264.533c-4.714,0-8.533-3.821-8.533-8.533c0-65.874-53.593-119.467-119.467-119.467 c-4.714,0-8.533-3.821-8.533-8.533c0-4.713,3.82-8.533,8.533-8.533c75.284,0,136.533,61.249,136.533,136.533 C392.533,260.713,388.714,264.533,384,264.533z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDAD2"
    },
    d: "M256,170.098c-47.481,0-85.902,38.422-85.902,85.902s38.422,85.902,85.902,85.902 s85.902-38.422,85.902-85.902S303.481,170.098,256,170.098z M256,270.222c-7.861,0-14.222-6.361-14.222-14.222 s6.361-14.222,14.222-14.222s14.222,6.361,14.222,14.222S263.861,270.222,256,270.222z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongPlay618A965);
export default __webpack_public_path__ + "static/media/long_play618a965.618a96548bb023630a012f58e76ee2d1.svg";
export { ForwardRef as ReactComponent };